<script setup lang="ts">
import Icon from '../icon/Icon.vue';
import type { IconName } from '../icon/Icon.types';

export type BadgeVariant = 'success' | 'warning' | 'critical' | 'info' | 'neutral';
export type BadgeType = 'basic' | 'tag' | 'chip' | 'pill';

export interface BadgeProps {
	variant?: BadgeVariant;
	type?: BadgeType;
	label: string;
	dot?: boolean;
	icon?: IconName;
}

withDefaults(defineProps<BadgeProps>(), {
	variant: 'neutral',
	dot: false,
});

const variantClasses: Record<BadgeVariant, string> = {
	success: 'bg-success/20 text-success',
	warning: 'bg-warning/20 text-warning',
	critical: 'bg-critical/20 text-critical',
	info: 'bg-info/20 text-info',
	neutral: 'bg-surface-input text-on-surface-variant',
};

const dotColours: Record<BadgeVariant, string> = {
	success: 'bg-success',
	warning: 'bg-warning',
	critical: 'bg-critical',
	info: 'bg-info',
	neutral: 'bg-on-surface-muted',
};
</script>

<template>
	<span class="inline-flex items-center justify-center gap-1 px-2 py-0.5 text-[10px] font-bold  tracking-wider" :class="[ (type === 'basic') || (type === 'pill') ? 'rounded-full uppercase' : 'rounded py-2',
		variantClasses[variant],
	]">
		<span v-if="dot" :class="['h-1.5 w-1.5 rounded-full', dotColours[variant]]" />
		<Icon v-if="type === 'tag' && icon" :name="icon" size="sm" />
		{{ label }}
		<Icon v-if="type==='chip'" name="cancel" size="sm" />
	</span>
</template>
